import dayjs, { Dayjs } from 'dayjs';
import { TaskActivityLogInterface } from '../../../mobx/interfaces/project';

export type CategorizedActivityLogs = {
  today: TaskActivityLogInterface[];
  week: TaskActivityLogInterface[];
  month: TaskActivityLogInterface[];
  older: TaskActivityLogInterface[];
};

export function categorizeActivityLogs(
  logs: TaskActivityLogInterface[] = [],
  referenceDate?: Dayjs
): CategorizedActivityLogs {
  const now = referenceDate ?? dayjs();
  const result: CategorizedActivityLogs = { today: [], week: [], month: [], older: [] };

  for (const log of logs) {
    const updatedTime = log.updatedTime;
    if (!updatedTime) continue;
    const updated = dayjs(updatedTime);

    if (updated.isSame(now, 'day')) result.today.push(log);
    else if (updated.isSame(now, 'week')) result.week.push(log);
    else if (updated.isSame(now, 'month')) result.month.push(log);
    else if (updated.isBefore(now, 'month')) result.older.push(log);
  }

  return result;
}
